import NotificationOutlineIcon from '@eduzz/houston-icons/NotificationOutline';
import Topbar from '@eduzz/ui-layout/Topbar';
import { Badge, Button, Divider, Popover, Tooltip } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import HistoryIcon from '@material-ui/icons/History';
import NotificationsOffOutlinedIcon from '@material-ui/icons/NotificationsOffOutlined';
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import notificationService from 'v2/services/notifications';
import webNotificationService from 'v2/services/webNotification';

import BankslipGenerated from './bankslipGenerated';
import HighChargebackRate from './chargebackRateAboveBlockLimit';
import Comission from './comission';
import { Dispute } from './dispute';
import ProductApproved from './productApproved';
import ProductReproved from './productReproved';
import Refund from './Refund';
import Report from './report';
import ReportNoData from './reportNoData';
import Sales from './sales';
import { useStyle } from './styles';

export default function Notifications() {
  const classes = useStyle();

  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const [lastUpdate] = useObservable(() => notificationService.getLastUpdate(), []);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const permissionDenied = webNotificationService.permission === 'denied';

  useEffect(() => webNotificationService.requestPermission(), []);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const total = (notifications || []).reduce((total, notification) => total + notification.quantity, 0);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Tooltip title='Notificações' placement='bottom'>
        <span>
          <Topbar.Action
            id='topbar-action-notifications'
            aria-label='mostrar notificações'
            onClick={handleClick}
            icon={
              <Badge badgeContent={total} classes={{ badge: classes.badge }} color='error' overlap='circular'>
                <NotificationOutlineIcon color='currentColor' size={24} />
              </Badge>
            }
          />
        </span>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        className={classes.popover}
      >
        <div>
          <Typography variant='subtitle1' className={classes.title} id='notification_popover'>
            Notificações
            <Tooltip
              title={permissionDenied ? 'Notificações do navegador estão desativadas' : 'Notificações do navegador estão ativadas'}
              placement='top'
            >
              {permissionDenied ? <NotificationsOffOutlinedIcon /> : <NotificationsOutlinedIcon />}
            </Tooltip>
          </Typography>
          <Divider />
          <div className={classes.container}>
            {!total ? (
              <div className={classes.empty}>Não há notificações</div>
            ) : (
              <div onClick={handleClose}>
                <Refund />
                <Dispute />
                <Sales />
                <BankslipGenerated />
                <ProductApproved />
                <ProductReproved />
                <Report />
                <ReportNoData />
                <Comission />
                <HighChargebackRate />
              </div>
            )}
          </div>
          <Divider />
          <div className={classes.footer}>
            <Button size='small' startIcon={<HistoryIcon />} disabled>
              {lastUpdate}
            </Button>
            <Link to='/producer/notifications?readAll=true'>
              <Tooltip title={'Ao exibir todas notificações todos contadores serão limpos'} placement='bottom'>
                <Button size='small' className={classes.button} onClick={handleClose}>
                  Exibir tudo
                </Button>
              </Tooltip>
            </Link>
          </div>
        </div>
      </Popover>
    </>
  );
}
